import React from 'react'
import { LuFileText, LuTriangleAlert } from 'react-icons/lu'

import QuestionSection from '@/components/modals/LogReferralModal/components/QuestionSection'
import SelectReferringUser from '@/components/modals/LogReferralModal/components/SelectReferringUser'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import useAppSelector from '@/hooks/useAppSelector'
import useCurrentCompanyUserOrFail from '@/hooks/useCurrentCompanyUserOrFail'
import { selectLogHistoricalReferralState } from '@/redux/slices/logHistoricalReferral'

interface Props {
  disabled: boolean
}

const SelectReferralUser: React.FC<Props> = ({ disabled }) => {
  const logHistoricalReferralState = useAppSelector(
    selectLogHistoricalReferralState,
  )
  const { isUserValid } = logHistoricalReferralState
  const currentCompanyUser = useCurrentCompanyUserOrFail()

  const selectedUser = logHistoricalReferralState.selectedUser

  const hasSelectedDifferentUser =
    !!selectedUser && selectedUser.id !== currentCompanyUser.id

  const shouldShowWarningAboutReferralNotBeingVisible =
    !currentCompanyUser.isCompanyAdmin && hasSelectedDifferentUser

  return (
    <QuestionSection
      title="Select person logging the referral"
      icon={<LuFileText />}
    >
      <SelectReferringUser disabled={disabled} />

      {shouldShowWarningAboutReferralNotBeingVisible && (
        <Alert variant="warning" className="mt-2">
          <LuTriangleAlert />
          <AlertDescription className="text-xs">
            <p>
              As you've selected a different user to be the referral logger and
              you're not an admin, you may not be able to see the referral once
              logged. Only admins can see referrals logged by other users.
            </p>
          </AlertDescription>
        </Alert>
      )}

      {!isUserValid && (
        <Alert variant="destructive" className="mt-2 border-destructive">
          <LuTriangleAlert />
          <AlertDescription className="text-xs">
            <p>
              There is a problem with detecting the user. Please{' '}
              <Button
                variant="plain"
                className="text-destructive underline"
                onClick={() => window.location.reload()}
              >
                refresh the page
              </Button>
              .
            </p>
          </AlertDescription>
        </Alert>
      )}
    </QuestionSection>
  )
}

export default SelectReferralUser
